<template>
  <div style="width: 100%;">
    <el-row type="flex" justify="center" align="middle">
      <form v-if="fields && form" :model="form" ref="newEntityForm" autocomplete="off">
        <table>
          <tr v-for="(row, idx) in rows" :key="idx">
            <td v-if="row[0]" style="width: 20%;">
              {{ row[0].required ? `*${row[0].label || row[0].name }` : (row[0].label || row[0].name )}}
            </td>
            <td v-if="row[0]" style="width: 30%;">
              <input
                :data-row="idx + 1"
                :data-col="1"
                data-type="input"
                :data-ref="`${idPrefix}${row[0].idNum}`"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length"
                :ref="`${idPrefix}${row[0].idNum}`"
                :autocomplete="'force_off_' + Math.floor(Math.random() * 10000 + 1)"
                class="keynav"
                :id="idPrefix + row[0].idNum"
                :name="row[0].name"
                :disabled="row[0].disabled"
                :placeholder="row[0].placeholder || ''"
                v-if="row[0].fieldType === 'input' && !row[0].autocomplete"
                v-model="form[row[0].name]"
                @focus="handleFocus"
                @blur="handleBlur(row[0].name)"
                @change="change">
              <el-autocomplete
                :data-row="idx + 1"
                :data-col="1"
                data-type="autocomplete"
                :data-ref="`autocomplete__${idPrefix + row[0].idNum}`"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length"
                :ref="`autocomplete__${idPrefix + row[0].idNum}`"
                class="keynav autocomplete"
                placeholder="Type to search..."
                @select="(selection) => handleSelect(selection, row[0].name)"
                :id="idPrefix + row[0].idNum"
                :name="row[0].name"
                :fetch-suggestions="row[0].searchAsync
                  ? querySearchAsync
                  : (query, cb) => autocompleteLocalSearch({ query, ref: `autocomplete__${idPrefix}${row[0].idNum}`, field: row[0] }, cb)"
                :props="{ label: 'label', value: 'value' }"
                :trigger-on-focus="row[0].triggerOnFocus"
                :disabled="row[0].disabled"
                v-else-if="row[0].fieldType === 'input' && row[0].autocomplete"
                v-model="form[row[0].name].label"
                @focus="handleFocus"
                @blur="handleBlur(row[0].name)"
                @change="change">
              </el-autocomplete>
              <el-select
                :data-row="idx + 1"
                :data-col="1"
                data-type="select"
                :data-ref="idPrefix + row[0].idNum"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length"
                class="keynav"
                v-else-if="row[0].fieldType === 'select' && form[row[0].name].hasOwnProperty('value')"
                v-model="form[row[0].name].value"
                @focus="handleFocus"
                :ref="idPrefix + row[0].idNum"
                :id="idPrefix + row[0].idNum"
                :name="row[0].name"
                :filterable="row[0].filterable"
                :multiple="row[0].multiple"
                :loading="null"
                :placeholder="row[0].filterable ? 'Search' : 'Select option'"
                :disabled="row[0].disabled"
                @change="handleSelectChange(row[0].name)">
                <el-option
                  v-for="item in row[0].options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{ item.label }}
                </el-option>
              </el-select>
              <input
                :data-row="idx + 1"
                :data-col="1"
                data-type="checkbox"
                :data-ref="`${idPrefix}${row[0].idNum}`"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length"
                type="checkbox"
                class="keynav form-checkbox"
                :ref="`${idPrefix}${row[0].idNum}`"
                :id="idPrefix + row[0].idNum"
                :name="row[0].name"
                :disabled="row[0].disabled"
                v-else-if="row[0].fieldType === 'checkbox'"
                v-model="form[row[0].name]"
                @focus="handleFocus"
                @change="change">
              <textarea
                :data-row="idx + 1"
                :data-col="1"
                data-type="textarea"
                :data-ref="`${idPrefix}${row[0].idNum}`"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length"
                class="keynav"
                :ref="`${idPrefix}${row[0].idNum}`"
                :id="idPrefix + row[0].idNum"
                :name="row[0].name"
                :disabled="row[0].disabled"
                :rows="1"
                v-else-if="row[0].fieldType === 'textarea'"
                v-model="form[row[0].name]"
                @focus="handleFocus"
                @change="change">
              </textarea>
            </td>
            <td v-if="row[1]" style="width: 20%;">
              {{ row[1].required ? `*${row[1].label || row[1].name }` : (row[1].label || row[1].name )}}
            </td>
            <td v-if="row[1]" style="width: 30%;">
              <input
                :data-row="idx + 1"
                :data-col="2"
                data-type="input"
                :data-ref="idPrefix + row[1].idNum"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length - 1"
                :ref="idPrefix + row[1].idNum"
                :autocomplete="'force_off_' + Math.floor(Math.random() * 10000 + 1)"
                class="keynav"
                :id="idPrefix + row[1].idNum"
                :name="row[1].name"
                :disabled="row[1].disabled"
                :placeholder="row[1].placeholder || ''"
                v-if="row[1].fieldType === 'input' && !row[1].autocomplete"
                v-model="form[row[1].name]"
                @focus="handleFocus"
                @blur="handleBlur(row[1].name)"
                @change="change">
              <el-autocomplete
                :data-row="idx + 1"
                :data-col="2"
                data-type="autocomplete"
                :data-ref="`autocomplete__${idPrefix + row[1].idNum}`"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length - 1"
                class="keynav autocomplete"
                placeholder="Type to search..."
                @select="(selection) => handleSelect(selection, row[1].name)"
                :ref="`autocomplete__${idPrefix + row[1].idNum}`"
                :id="idPrefix + row[1].idNum"
                :name="row[1].name"
                :fetch-suggestions="row[1].searchAsync
                  ? querySearchAsync
                  : (query, cb) => autocompleteLocalSearch({ query, ref: `autocomplete__${idPrefix}${row[1].idNum}`, field: row[1] }, cb)"
                :props="{ label: 'label', value: 'value' }"
                :trigger-on-focus="row[1].triggerOnFocus"
                :disabled="row[1].disabled"
                v-else-if="row[1].fieldType === 'input' && row[1].autocomplete"
                v-model="form[row[1].name].label"
                @focus="handleFocus"
                @blur="handleBlur(row[1].name)"
                @change="change">
              </el-autocomplete>
              <el-select
                :data-row="idx + 1"
                :data-col="2"
                data-type="select"
                :data-ref="idPrefix + row[1].idNum"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length - 1"
                class="keynav"
                v-else-if="row[1].fieldType === 'select' && form[row[1].name].hasOwnProperty('value')"
                v-model="form[row[1].name].value"
                @focus="handleFocus"
                :ref="idPrefix + row[1].idNum"
                :id="idPrefix + row[1].idNum"
                :name="row[1].name"
                :filterable="row[1].filterable"
                :multiple="row[1].multiple"
                :loading="null"
                :placeholder="row[1].filterable ? 'Search' : 'Select option'"
                :disabled="row[1].disabled"
                @change="handleSelectChange(row[1].name)">
                <el-option
                  v-for="item in row[1].options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{ item.label }}
                </el-option>
              </el-select>
              <input
                :data-row="idx + 1"
                :data-col="2"
                data-type="checkbox"
                :data-ref="idPrefix + row[1].idNum"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length - 1"
                :ref="idPrefix + row[1].idNum"
                type="checkbox"
                class="keynav form-checkbox"
                :id="idPrefix + row[1].idNum"
                :name="row[1].name"
                :disabled="row[1].disabled"
                v-else-if="row[1].fieldType === 'checkbox'"
                v-model="form[row[1].name]"
                @focus="handleFocus"
                @change="change">
              <textarea
                :data-row="idx + 1"
                :data-col="2"
                data-type="textarea"
                :data-ref="idPrefix + row[1].idNum"
                :data-formnum="formNum"
                :data-lastincol="(idx + 1) === rows.length - 1"
                :ref="idPrefix + row[1].idNum"
                class="keynav"
                :id="idPrefix + row[1].idNum"
                :name="row[1].name"
                :disabled="row[1].disabled"
                :rows="1"
                v-else-if="row[1].fieldType === 'textarea'"
                v-model="form[row[1].name]"
                @focus="handleFocus"
                @change="change">
              </textarea>
            </td>
          </tr>
        </table>
      </form>
    </el-row>
  </div>
</template>

<script>
  import Mousetrap from 'mousetrap'
  import buildAddressString from '../utils/helpers/BuildAddressString'
  import buildNoDataObject from '../utils/helpers/BuildNoDataObject'
  import buildLabelString from '../utils/helpers/BuildLabelString'
  import { searchMixins } from '@/Mixins/SearchMixins'

  export default {
    props: {
      entityType: String,
      formNum: Number,
      active: Number,
      visible: Boolean,
      fields: Array,
      form: Object,                               // When multiple instances of this component are loaded in the DOM, it is necessary to
      idPrefix: String,                           // <--- pass an id prefix in order to prevent duplicate ids in the DOM. Whatever prefix you pass,
      formChanged: Boolean,
      modalOpen: Boolean
    },
    mixins: [ searchMixins ],
    data () {
      return {
        suggestions: {
          active: '',
          currency: [],
          parent: []
        },
        loading: false,
        searchTimeout: null,
        mousetrap: null
      }
    },
    methods: {
      handleFocus () {
        this.$emit('focusEvent', this.formNum)
      },
      handleBlur (fieldName) {
        this.$emit('blurEvent', fieldName)
      },
      handleSelectChange (fieldName) {
        this.change()
        this.handleBlur(fieldName)
      },
      change (value) {
        this.$emit('update:form', this.form)
        this.$emit('formChanged', value)
      },
      getFieldName () {
        return document.activeElement.name
      },
      /**
       * Bind navigation keys to actions using Mousetrap
       */
      bindMousetrapToNavKeys () {
        if (this.$refs && this.$refs['newEntityForm']) {
          this.mousetrap = new Mousetrap(this.$refs['newEntityForm'])
          this.mousetrap.bind(['up', 'down', 'left', 'right'], this.handleArrowKeys)
          this.mousetrap.bind('tab', this.handleTabKey)
          this.mousetrap.bind('enter', this.handleEnterKey)
          this.mousetrap.bind('shift+tab', this.handleShiftTab)
        }
      },
      /**
       * Unbinds mousetrap from this form
       */
      unbindMousetrapFromNavKeys () {
        if (this.mousetrap) {
          this.mousetrap.unbind(['up', 'down', 'left', 'right', 'tab', 'enter'])
          this.mousetrap.unbind('shift+tab')
          this.mousetrap = null
        }
      },
      /**
       * Handle grid navigation using arrow keys
       * @param e   Keypress event
       */
      handleArrowKeys (e) {
        let { row, col, type, ref, lastincol } = e.target.dataset
        let formnum = null
        ref = this.$refs[ref][0]
        if (!(e && e.target)) return
        switch (e.key) {
          case 'ArrowUp':
          case 'ArrowDown':
            if (!(ref && (ref.suggestionVisible || ref.visible))) {
              row = e.key === 'ArrowUp' ? `${parseInt(row) - 1}` : `${parseInt(row) + 1}`
            }
            if (lastincol && parseInt(col) === 1) {
              row = 1
              col = 2
            } else if (lastincol && parseInt(col) === 2) {
              row = 1
              col = 1
              formnum = this.formNum + 1
            }
            break
          case 'ArrowLeft':
          case 'ArrowRight':
            const { selectionStart, value } = e.target
            this.checkFormField(row, col)
            if (!(['select', 'autocomplete'].includes(type) && (ref.suggestionVisible || ref.visible))) {
              if (type !== 'checkbox' && e.key === 'ArrowRight' && value && (selectionStart !== value.length)) {             // if a field has text in it, make sure that the cursor is at the end or beginning of the text before navigating
                return
              } else if (type !== 'checkbox' && e.key === 'ArrowLeft' && value && value.length && (selectionStart !== 0)) {
                return
              }
              col = e.key === 'ArrowLeft' ? `${parseInt(col) - 1}` : `${parseInt(col) + 1}`
            }
        }
        this.checkFormField(this.getFieldName())
        this.navigateCells(row, col, formnum)
      },
      /**
       * Handle grid navigation using enter
       * @param e   Keypress event
       */
      handleEnterKey (e) {
        if (!(e && e.target && e.target.dataset)) return
        let { row, col, lastincol } = e.target.dataset
        let formnum = null
        if (lastincol && parseInt(col) === 1) {
          row = 1
          col = 2
        } else if (lastincol && parseInt(col) === 2) {
          row = 1
          col = 1
          formnum = this.formNum + 1
        } else {
          row = `${parseInt(row) + 1}`
        }
        this.checkFormField(this.getFieldName())
        this.navigateCells(row, col, formnum)
      },
      /**
       * Handle grid navigation using tab
       * @param e   Keypress event
       */
      handleTabKey (e) {
        e.preventDefault()
        this.handleEnterKey(e)
      },
      /**
       * Handle grid navigation using shift+tab
       * @param e   Keypress event
       */
      handleShiftTab (e) {
        if (!(e && e.target && e.target.dataset)) return
        let { row, col } = e.target.dataset
        let formnum = null
        if (parseInt(row) === 1 && parseInt(col) === 1 && this.formNum > 1) {
          return
        } else {
          e.preventDefault()
          row = `${parseInt(row) - 1}`
        }
        this.checkFormField(this.getFieldName())
        this.navigateCells(row, col, formnum)
      },
      /**
       * Handle grid navigation using arrow keys
       * @param row       The destination row
       * @param col       The destination col
       * @param formnum
       */
      async navigateCells (row = 1, col = 1, formnum = null) {
        row = parseInt(row)
        col = parseInt(col)
        const destination = document.querySelector(`[data-row="${row}"][data-col="${col}"][data-formnum="${formnum || this.formNum}"]`)
        if (destination) {
          destination.focus()
        }
      },
      /**
       * Verifies a form field for validity
       * @param fieldName
       */
      checkFormField (fieldName) {
        const field = this.form[fieldName]
        const fieldData = this.fields.find(field => field.name === fieldName)
        if (field && field.hasOwnProperty('value')) {
          if (field && fieldData && fieldData.required && !field.value) {
            document.getElementsByName(fieldName)[0].style.backgroundColor = '#ff49493d'                    // Set color to indicate that value has been set
          } else {
            document.getElementsByName(fieldName)[0].style.backgroundColor = '#fff'                         // Set color to indicate that value has been set
          }
        }
      },
      /**
       * Highlights the first autocomplete result after search
       * @param ref   The ref key of the autocomplete component
       */
      highlightFirstAutocompleteResult (ref = null) {
        const { $refs } = this
        const highlight = (r) => {
          if (r.includes('autocomplete') && Array.isArray($refs[r]) && $refs[r][0].suggestions && $refs[r][0].suggestions.length) {
            this.$refs[r][0].highlight(0)
          }
        }
        if (ref) {
          highlight(ref)
        } else {
          for (let r in $refs) {
            highlight(r)
          }
        }
      },
      /**
       * Handles async/remote autocomplete searches
       * @param query
       * @param cb
       */
      querySearchAsync (query, cb) {                                                                        // Handles loading suggestions (loaded via ajax fetch)
        const executeSearch = () => {
          this.clearActiveSuggestionListIndicator('')
          const el = document.activeElement.name
          let results = query ? this.suggestions[el].filter(this.createFilter(query)) : this.suggestions[el]
          if (query && query !== '' && query.length >= 1) {
            let name
            let queryObj = { search: query }
            switch (el) {
              case 'currency':
                name = 'currencies'
                break
              case 'parent':
                name = 'vendors'
            }
            this.$store.dispatch('searchWithQuery', { endpoint: name, query: queryObj })
              .then(r => {
                this.loadingOptions = false
                if (r && r.count) {
                  results = Object.values(r.entities[name]).map(v => {
                    let ret = {}
                    ret.label = name !== 'addresses' ? buildLabelString(v) : buildAddressString(v)
                    ret.value = v.id
                    return ret
                  })
                  this.setActiveSuggestionListIndicator(el, true)
                  cb(results)
                } else {
                  cb([buildNoDataObject(el)])
                }
              })
              .then(() => {
                const { $refs } = this
                for (let r in $refs) {
                  if (r.includes('autocomplete') && $refs[r][0] && $refs[r][0].suggestions.length) {
                    this.$refs[r][0].highlight(0)
                  }
                }
              })
              .catch(e => {
                console.log(e)
                cb([buildNoDataObject(el)])
              })
          }
        }
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => executeSearch(), 200)
      },
      /**
       * Caches the selected search result for autocomplete fields
       * @param fieldName   The name of the field for which to cache the selected search result
       */
      cacheSelectionResults (fieldName) {
        let storeActionPayload
        switch (fieldName) {
          case 'vendor':
          case 'parent':
            storeActionPayload = { entityType: 'vendors', mutation: 'RECEIVE_VENDORS' }
            break
          case 'currency':
            storeActionPayload = { entityType: 'currencies', mutation: 'RECEIVE_CURRENCIES' }
        }
        this.$store.dispatch('storeLastSearchResults', storeActionPayload)
      },
      createFilter (query) {
        const { name } = document.activeElement
        return (link) => link[name].indexOf(query.toLowerCase()) === 0
      },
      setActiveSuggestionListIndicator (field, asyncSuggestionList) {
        if (asyncSuggestionList) {
          this.suggestions.active = field
        }
      },
      clearActiveSuggestionListIndicator () {
        if (this.suggestions) this.suggestions.active = ''
      },
      /**
       * Handles autocomplete selection
       * @param selection
       * @param fieldName
       * @return {*}
       */
      handleSelect (selection, fieldName = null) {
        if (selection.label === 'No data' && !selection.value) {
          this.form[fieldName] = { label: '', value: '' }
          return selection.label
        }
        this.form[fieldName] = Object.assign({}, selection)
        const field = this.fields.find(field => field.name === fieldName)
        if (field.searchAsync) this.cacheSelectionResults(fieldName)
        this.checkFormField(fieldName)
        this.$emit('formChanged')
        this.$emit('optionSelected', fieldName)
        return selection.label
      },
      /**
       * Steps through the form element and finds all children where data-type is either autocomplete or select. Then
       * iterates through these fields and removes the dataset properties from the outer/wrapper div and sets them
       * on actual input child element. This makes keyboard nav possible
       */
      initializeFormFields () {
        const fields = [
          ...this.$refs.newEntityForm.querySelectorAll(`[data-type="autocomplete"]`),
          ...this.$refs.newEntityForm.querySelectorAll(`[data-type="select"]`)
        ]
        fields.forEach(field => {
          const data = { ...field.dataset }
          field.removeAttribute('data-row')
          field.removeAttribute('data-col')
          field.removeAttribute('data-ref')
          field.removeAttribute('data-type')
          field.removeAttribute('data-formnum')
          let nestedInputFields = field.getElementsByTagName('input')
          if (nestedInputFields && nestedInputFields.length) {
            nestedInputFields[0].setAttribute('autocomplete', 'force_off_' + Math.floor(Math.random() * 10000 + 1))
            nestedInputFields[0].setAttribute('data-row', data.row)
            nestedInputFields[0].setAttribute('data-col', data.col)
            nestedInputFields[0].setAttribute('data-ref', data.ref)
            nestedInputFields[0].setAttribute('data-type', data.type)
            nestedInputFields[0].setAttribute('data-formnum', data.formnum)
          }
        })
      }
    },
    computed: {
      rows () {
        let ret = []
        const { fields } = this
        fields.map((v, k) => {
          if (k % 2 === 0) ret.push([fields[k], fields[k + 1]])
        })
        return ret
      }
    },
    watch: {
      active () {
        if (this.formNum === this.active) {
          if (!this.mousetrap) {
            this.bindMousetrapToNavKeys()
          }
        } else {
          this.unbindMousetrapFromNavKeys()
        }
      }
    },
    mounted () {
      this.initializeFormFields()
      if (this.formNum === this.active) {
        this.bindMousetrapToNavKeys()
      }
    }
  }
</script>

<style>
  td input, textarea, select {
    border: none !important;
    height: 22px !important;
  }
</style>

<style scoped>
  /*Table style properties*/
  table {
    width: 100%;
    margin-bottom: 1em;
    border-collapse: collapse;
  }
  td {
    padding: 0.2em;
    border: 1px solid #ccc;
    background-color: #ffffff;
    font-size: 12px;
  }
  td:first-child {
    text-align: right;
    background-color: #efefef;
    padding: 3px;
  }
  td:nth-child(2) {
    text-align: left;
  }
  td:nth-child(3) {
    text-align: right;
    background-color: #efefef;
    padding: 3px;
  }
  td:nth-child(4) {
    text-align: left;
  }
  .form-checkbox {
    padding: 0 10px;
  }
  /*.keynav {*/
    /*width: 100%;*/
  /*}*/
  .keynav:not(.form-checkbox) {
    width: 100%;
  }
  select {
    border: none;
    background-color: #fff
  }
</style>



// WEBPACK FOOTER //
// src/components/StandardForm.vue